import React from 'react';
import styled from 'styled-components';
import { Checkbox as PrimereactCheckbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { Typography } from "../Typography";

interface FormCheckboxProps {
  name: string;
  label: React.ReactNode;
  checked: boolean;
  onChange: (event: CheckboxChangeEvent) => void;
  disabled?: boolean;
  tooltip?: string;
  inputId?: string; 
}

export const Checkbox: React.FC<FormCheckboxProps> = ({
  name,
  label,
  checked,
  onChange,
  disabled = false,
  tooltip,
  inputId,
}) => {
  const id = inputId || `checkbox-${name}`;

  return (
    <Container>
      <StyledCheckbox
        checked={checked}
        inputId={id}
        onChange={onChange}
        disabled={disabled}
      />
      <Typography variant="checkbox">
        <label htmlFor={id}>{label}</label>
      </Typography>
      {disabled && tooltip && <Tooltip>{tooltip}</Tooltip>}
    </Container>
  );
};

// Styled container
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  cursor: pointer;
`;

// Styled PrimeReact checkbox
const StyledCheckbox = styled(PrimereactCheckbox)`
  z-index: 10;

  &.p-checkbox.p-highlight .p-checkbox-box {
    border-color: ${({ theme }) => theme.palette.checkbox.primary};
    background-color: ${({ theme }) => theme.palette.checkbox.primary};
  }
`;

// Tooltip hover-styled
const Tooltip = styled.div`
  position: absolute;
  top: -28px;
  left: 0;
  background: #333;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 5px;
  white-space: nowrap;
`;
